
import React, { useEffect, useState } from 'react';
import { useScoreboardState } from '@/hooks/useScoreboardState';

interface ScoreboardXMLProps {
  kitNumber: string;
}

export function ScoreboardXML({ kitNumber }: ScoreboardXMLProps) {
  const [xmlContent, setXmlContent] = useState<string>('');
  
  const {
    teamAScore,
    teamBScore,
    balls,
    strikes,
    outs,
    count,
    isTopInning,
    baseRunners,
    teamAName,
    teamBName,
  } = useScoreboardState(kitNumber);

  useEffect(() => {
    // Create XML content based on scoreboard state
    const createXML = () => {
      const data = [
        { title: "HomeTeam", value: teamBName || "Team B" },
        { title: "AwayTeam", value: teamAName || "Team A" },
        { title: "HomeScore", value: teamBScore.toString() },
        { title: "AwayScore", value: teamAScore.toString() },
        { title: "Inning", value: count === 99 ? "Final" : count.toString() },
        { title: "InningHalf", value: isTopInning ? "Top" : "Bottom" },
        { title: "Balls", value: balls.toString() },
        { title: "Strikes", value: strikes.toString() },
        { title: "Outs", value: outs.toString() },
        { title: "RunnerOnFirst", value: baseRunners[0] ? "1" : "0" },
        { title: "RunnerOnSecond", value: baseRunners[1] ? "1" : "0" },
        { title: "RunnerOnThird", value: baseRunners[2] ? "1" : "0" },
      ];

      let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
      xml += '<scoreboard>\n';
      
      data.forEach(item => {
        xml += `  <row>\n`;
        xml += `    <title>${item.title}</title>\n`;
        xml += `    <data>${item.value}</data>\n`;
        xml += `  </row>\n`;
      });
      
      xml += '</scoreboard>';
      
      return xml;
    };

    setXmlContent(createXML());
  }, [teamAScore, teamBScore, balls, strikes, outs, count, isTopInning, baseRunners, teamAName, teamBName]);

  // Set the correct content type for XML
  useEffect(() => {
    document.querySelector('meta[http-equiv="Content-Type"]')?.remove();
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Type');
    meta.setAttribute('content', 'text/xml; charset=utf-8');
    document.head.appendChild(meta);

    return () => {
      meta.remove();
    };
  }, []);

  // This component renders a pre-formatted XML for better viewing in browser
  // The actual XML is properly escaped to avoid DOM parsing issues
  return (
    <pre className="font-mono text-xs whitespace-pre-wrap bg-black text-green-400 p-4">
      {xmlContent}
    </pre>
  );
}
